import React from "react";
import { Card, Typography, Button, theme } from "antd";
import { SettingOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface EmptyFormCardProps {
  loading?: boolean;
  icon?: React.ReactNode;
  message: string;
  children?: React.ReactNode;
}

export const EmptyFormCard: React.FC<EmptyFormCardProps> = ({
  loading = false,
  icon = <SettingOutlined style={{ fontSize: 58 }} />,
  message,
  children,
}) => {
  const { token } = theme.useToken();

  return (
    <Card
      loading={loading}
      style={{
        height: 269,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {icon && (
        <div
          style={{ color: token.colorPrimary, fontSize: 58, marginBottom: 14 }}
        >
          {icon}
        </div>
      )}
      <Text style={{ display: "block", marginBottom: 16 }}>{message}</Text>

      {children && <div style={{ marginBottom: 16 }}>{children}</div>}
    </Card>
  );
};
